export enum RuleTypeModel {
    CHARGES = "charge",
    PROMOTION = "promotion"
}